class imagesRegister {

    static images = [];
    static page_number = 1;
    static uploaded_image = null;

    static setImages(data, page){
        imagesRegister.images = data;
        imagesRegister.page_number = page;
        try{
            sessionStorage.setItem('images', JSON.stringify(imagesRegister.images));
            sessionStorage.setItem('images_page', JSON.stringify(imagesRegister.page_number));
        }catch (e) {}
    }

    static getImages(data){
        try {
            if(JSON.parse(sessionStorage.getItem('images'))){
                return JSON.parse(sessionStorage.getItem('images'));
            }else{
                return imagesRegister.images;
            }
        }catch (e) {
            return imagesRegister.images;
        }
    }

    static removeImages(){
        imagesRegister.images = [];
        imagesRegister.page_number = 1;
        try {
            sessionStorage.removeItem('images');
            sessionStorage.removeItem('images_page');
        }catch (e) {}
    }

    static getPage(){
        try {
            if(JSON.parse(sessionStorage.getItem('images_page'))){
                return JSON.parse(sessionStorage.getItem('images_page'));
            }else{
                return imagesRegister.page_number;
            }
        }catch (e) {
            return imagesRegister.page_number;
        }
    }

    static setUpload(data){
        imagesRegister.uploaded_image = data;
    }

    //SHORTENER
    static set(data, page){
        imagesRegister.setImages(data, page);
    }

    static get(){
        return imagesRegister.getImages();
    }

    static remove(){
        imagesRegister.removeImages();
    }

    static upload(data){
        imagesRegister.setUpload(data);
    }

    static download(){
        return imagesRegister.uploaded_image;
    }

    static page(){
        return imagesRegister.getPage();
    }


}

export {imagesRegister}


// WEBPACK FOOTER //
// ./src/services/imagesRegister.js